export type {
  UniversalGalleryItemBase,
  UniversalGalleryItemDynamic,
  UniversalGallerySectionBase,
  UniversalGallerySectionDynamic,
} from "./model";
export {
  UniversalGalleryItemSchema,
  UniversalGallerySectionSchema,
} from "./model/schemas";
export {
  UniversalGallery,
  type UniversalGalleryProps,
} from "./universal-gallery";
